import * as React from "react";
import { useState } from "react";
import styled, { css } from "styled-components";
import { Icon, DatePicker, Switch } from "components/common";
const Column = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Row = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.6rem;
`;
const DateRow = styled(Row)(
  ({ theme }) => css`
    margin-top: 10px;
    margin-bottom: -10px;
    padding: 5px 10px;
    border-radius: 15px;
    font-size: 0.9rem;
    font-weight: normal;
    background-color: ${theme.colors.global.background};
    color: ${theme.colors.text.primary};
  `
);
const ClearDate = styled(Icon)(
  ({ theme }) => css`
    padding-left: 5px;
    cursor: pointer;
    color: ${theme.colors.variant.default};
  `
);
const DateFilter = ({ values: valuesProps, onChange }) => {
  const [currentDate, setCurrentDate] = useState(null);
  const [dateRange, setDateRange] = useState(false);
  const values = valuesProps != null ? valuesProps : [];
  const toggleDateRange = (e) => {
    const auxDateRange = e.target.checked;
    if (!auxDateRange && values.length === 2) onChange([]);
    setDateRange(auxDateRange);
  };
  const filterIncluded = (fDate) => !!values.find((value) => value === fDate);
  const onDateChange = (day, _, e) => {
    e.stopPropagation();
    const isoDate = [
      day.getFullYear(),
      (day.getMonth() + 1).toString().padStart(2, "0"),
      day.getDate().toString().padStart(2, "0")
    ].join("-");
    if (filterIncluded(isoDate)) {
      onChange(values.filter((value) => value !== isoDate));
    } else if (values.length === 2 || !dateRange) {
      onChange([isoDate]);
    } else {
      onChange(
        [...values, isoDate].sort((d1, d2) => {
          const d1Int = new Date(d1).getTime();
          const d2Int = new Date(d2).getTime();
          if (d1Int > d2Int) return 1;
          if (d1Int < d2Int) return -1;
          return 0;
        })
      );
    }
    setCurrentDate(isoDate);
  };
  return /* @__PURE__ */ React.createElement(Column, null, /* @__PURE__ */ React.createElement(Row, null, /* @__PURE__ */ React.createElement("span", null, "Single Date"), /* @__PURE__ */ React.createElement(
    Switch,
    {
      checked: dateRange,
      "aria-label": `Select type ${dateRange ? "single date" : "range"}`,
      onChange: toggleDateRange
    }
  ), /* @__PURE__ */ React.createElement("span", null, "Range")), values.length > 0 && /* @__PURE__ */ React.createElement(DateRow, null, values.join(" to "), /* @__PURE__ */ React.createElement(ClearDate, { "data-testid": "clear-date", name: "close", size: "xs", onClick: () => onChange([]) })), /* @__PURE__ */ React.createElement(DatePicker, { date: currentDate, onChange: onDateChange }));
};
export default DateFilter;
